import { render, staticRenderFns } from "./ProposalsModal.vue?vue&type=template&id=7c6bee8f&"
import script from "./ProposalsModal.vue?vue&type=script&lang=js&"
export * from "./ProposalsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProposalsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports